// Restricted, source-preserving CSS background editor. No arbitrary CSS/URL
// insertion and no inferred VML edits. Unknown/ambiguous forms stay Code-only.
export const LOCAL_IMAGE = /^(?:\.\/)?images\/[A-Za-z0-9][A-Za-z0-9._-]{0,119}$/;
const COLOR = /^#(?:[\da-f]{3}|[\da-f]{6}|[\da-f]{8})$/i;
const KEYS = new Set(['background','background-image','background-size','background-repeat','background-position','background-color']);
export function styleDeclarations(style) {
  if(typeof style!=='string'||style.length>16000||/[\\&<>]|\/\*|\*\//.test(style))return null;
  const rows=[];let start=0,quote='',depth=0;
  for(let i=0;i<=style.length;i++) {
    const c=style[i];
    if(quote){if(c===quote)quote='';continue;}
    if(c==='"'||c==="'"){quote=c;continue;}
    if(c==='('){if(++depth>8)return null;continue;}
    if(c===')'){if(--depth<0)return null;continue;}
    if((c===';'&&!depth)||i===style.length){
      const raw=style.slice(start,i);if(raw.trim()){
        const m=/^\s*([\w-]+)\s*:\s*([\s\S]*?)\s*$/.exec(raw);if(!m)return null;
        const valueStart=start+raw.indexOf(':')+1+raw.slice(raw.indexOf(':')+1).search(/\S/);
        rows.push({property:m[1].toLowerCase(),value:m[2],start,end:i+(c===';'?1:0),valueStart,valueEnd:valueStart+m[2].length});
      }start=i+1;
    }
  }
  return quote||depth?null:rows;
}
export function backgroundValue(style) {
  const rows=styleDeclarations(style);if(!rows)return null;
  const bg=rows.filter(r=>KEYS.has(r.property));
  if(new Set(bg.map(r=>r.property)).size!==bg.length||bg.some(r=>/!important/i.test(r.value)))return null;
  const by=new Map(bg.map(r=>[r.property,r.value]));
  if(by.has('background')&&!COLOR.test(by.get('background')))return null;
  if(by.has('background')&&by.has('background-color'))return null;
  const image=by.get('background-image')||'none', m=/^url\((?:"([^"]*)"|'([^']*)'|([^()'"\s]+))\)$/.exec(image);
  const src=m&&(m[1]??m[2]??m[3]);if(image!=='none'&&(!src||!LOCAL_IMAGE.test(src)||src.trim()!==src))return null;
  const size=by.get('background-size')||'auto',repeat=by.get('background-repeat')||'repeat',position=by.get('background-position')||'0% 0%';
  if(!['auto','cover','contain'].includes(size)||!['repeat','no-repeat'].includes(repeat)||!['0% 0%','center','center center','top center','bottom center'].includes(position))return null;
  const color=by.get('background-color')||by.get('background')||'#FFFFFF';if(!COLOR.test(color))return null;
  return JSON.stringify({enabled:!!src,src:src||'',fit:repeat==='repeat'?'tile':size==='contain'?'contain':'cover',color,position});
}
export function editBackground(style, input) {
  const rows=styleDeclarations(style);if(!rows||backgroundValue(style)===null)throw Error('Unsupported background source; use Code.');
  let value;try{value=JSON.parse(input);}catch{throw Error('Invalid background controls.');}
  if(!value||Object.keys(value).sort().join()!=='color,enabled,fit,position,src'||typeof value.enabled!=='boolean'
    ||typeof value.src!=='string'||(value.enabled&&(!LOCAL_IMAGE.test(value.src)||value.src.trim()!==value.src))
    ||!['cover','contain','tile'].includes(value.fit)||typeof value.color!=='string'||!COLOR.test(value.color)
    ||!['0% 0%','center','center center','top center','bottom center'].includes(value.position))throw Error('Choose a bundled image, supported fit, position and hex fallback.');
  let base=style;
  for(const row of rows.filter(r=>KEYS.has(r.property)).reverse())base=base.slice(0,row.start)+base.slice(row.end);
  const declarations=value.enabled?[`background-image:url(${value.src})`,`background-size:${value.fit==='tile'?'auto':value.fit}`,
    `background-repeat:${value.fit==='tile'?'repeat':'no-repeat'}`,`background-position:${value.position}`]:['background-image:none'];
  declarations.push(`background-color:${value.color}`);
  return {value:JSON.stringify({enabled:value.enabled,src:value.enabled?value.src:'',fit:value.fit,color:value.color,position:value.position}),
    style:base+(base.trim()&&!base.trimEnd().endsWith(';')?';':'')+declarations.join(';')+';'};
}
